import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { ValidationError } from '@eliadmin/core/src/api/errors';

/**
 * The 422 rule of the core forms: every message goes onto the field `fieldOf` names for it, the
 * first such field takes the focus. Returns the messages that found no field (the caller shows them
 * as the general result) – an empty list for any other error, `null` when every message landed on
 * a field.
 */
export function applyServerErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fieldOf: (field: string) => Path<T> | undefined,
): string[] | null {
  if (!(error instanceof ValidationError)) return [];

  const unmapped: string[] = [];
  let focused = false;
  for (const [field, messages] of Object.entries(error.fields)) {
    const target = fieldOf(field);
    if (!target) {
      unmapped.push(...messages);
      continue;
    }
    setError(target, { type: 'server', message: messages.join('\n') }, { shouldFocus: !focused });
    focused = true;
  }

  return unmapped.length || !focused ? unmapped : null;
}
